import socket from './socket';

const getListReportData = (listId, headers) =>
  socket.get(`/lists/${listId}/list-report-data`, undefined, headers);

const upsertListReportData = (listId, data, headers) =>
  socket.post(`/lists/${listId}/list-report-data`, data, headers);

const completeListReportData = (listId, headers) =>
  socket.post(`/lists/${listId}/list-report-data/complete`, undefined, headers);

export default {
  getListReportData,
  upsertListReportData,
  completeListReportData,
};
